/** Site locale + Google Translate cookies — mirrors website/script.js */

export const LANG_KEY = 'nkcSiteLang';

export const LANG_OPTIONS = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'ar', label: 'AR', name: 'العربية' },
];

export function getSiteLang() {
  try {
    const s = localStorage.getItem(LANG_KEY);
    if (s === 'fr' || s === 'ar' || s === 'en') return s;
  } catch {
    /* ignore */
  }
  return 'en';
}

export function setSiteLang(code) {
  const next = code === 'fr' || code === 'ar' ? code : 'en';
  try {
    localStorage.setItem(LANG_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}

export function applyDocumentLang(lang = getSiteLang()) {
  const code = lang === 'fr' || lang === 'ar' ? lang : 'en';
  document.documentElement.setAttribute('lang', code);
  document.documentElement.setAttribute('dir', code === 'ar' ? 'rtl' : 'ltr');
  document.body.classList.toggle('site-lang-fr', code === 'fr');
  document.body.classList.toggle('site-lang-ar', code === 'ar');
}

function googleTranslateCookieDomains(hostname) {
  const domains = [''];
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return domains;
  }
  const seen = { '': true };
  const add = (d) => {
    if (!d || seen[d]) return;
    seen[d] = true;
    domains.push(d);
  };
  add(hostname);
  add(`.${hostname}`);
  const parts = hostname.split('.');
  for (let i = 1; i < parts.length - 1; i++) {
    const parent = parts.slice(i).join('.');
    if (parent.includes('.')) {
      add(parent);
      add(`.${parent}`);
    }
  }
  if (parts.length >= 2) {
    const apex = parts.slice(-2).join('.');
    add(apex);
    add(`.${apex}`);
  }
  return domains;
}

function writeGoogleTranslateCookie(value, expires) {
  const host = window.location.hostname || '';
  const domains = googleTranslateCookieDomains(host);
  const exp = expires ? `;expires=${expires}` : '';
  domains.forEach((domain) => {
    const domainAttr = domain ? `;domain=${domain}` : '';
    // Do not set Secure — Google's googtrans cookie is non-Secure.
    document.cookie = `googtrans=${value}${exp};path=/${domainAttr}`;
    document.cookie = `googtrans=${value}${exp};path=${domainAttr}`;
  });
}

export function clearGoogleTranslateCookies() {
  writeGoogleTranslateCookie('', 'Thu, 01 Jan 1970 00:00:00 GMT');
}

export function stripGoogleTranslateHash() {
  if (window.location.hash.indexOf('googtrans') === -1) return;
  const clean = window.location.pathname + window.location.search;
  try {
    window.history.replaceState(null, '', clean);
  } catch {
    window.location.hash = '';
  }
}

function readGoogleTranslateCookie() {
  const raw = document.cookie || '';
  const parts = raw.split(';');
  let found = '';
  for (let i = 0; i < parts.length; i++) {
    const p = parts[i].replace(/^\s+/, '');
    if (p.indexOf('googtrans=') === 0) {
      found = decodeURIComponent(p.slice('googtrans='.length));
    }
  }
  return found;
}

export function setGoogleTranslateCookie(lang) {
  clearGoogleTranslateCookies();
  if (lang === 'en') return;
  writeGoogleTranslateCookie(`/en/${lang}`, '');
}

/** If localStorage says AR/FR but an old googtrans cookie won, force-fix once. */
export function ensureGoogleTranslateMatchesPreference() {
  const lang = getSiteLang();
  const want = lang === 'en' ? '' : `/en/${lang}`;
  const current = readGoogleTranslateCookie();
  const ok =
    lang === 'en'
      ? !current || current === '/en/en' || current === '/auto/en'
      : current === want;
  if (ok) {
    try {
      sessionStorage.removeItem('nkcGoogTransFix');
    } catch {
      /* ignore */
    }
    return false;
  }
  const fixKey = 'nkcGoogTransFix';
  try {
    if (sessionStorage.getItem(fixKey) === (want || 'en')) return false;
    sessionStorage.setItem(fixKey, want || 'en');
  } catch {
    /* ignore */
  }
  setGoogleTranslateCookie(lang);
  stripGoogleTranslateHash();
  window.location.reload();
  return true;
}

/** Switch language (cookie + preference) and reload so Google Translate applies. */
export function switchSiteLanguage(code) {
  const next = setSiteLang(code);
  if (next === 'en') {
    clearGoogleTranslateCookies();
  } else {
    setGoogleTranslateCookie(next);
  }
  stripGoogleTranslateHash();
  window.location.reload();
}

export function langLabel(code = getSiteLang()) {
  const opt = LANG_OPTIONS.find((o) => o.code === code);
  return opt?.label || 'EN';
}
